import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-zinc-100" data-id="element-74" data-mp="1hdupklvgf9bb">
      <div className="max-w-3xl mx-auto" data-id="element-75" data-mp="1cf9ko959c1gj">
        <div className="text-center mb-16" data-id="element-76" data-mp="1cgb7favmyce3">
          <h2 className="text-3xl md:text-5xl font-black uppercase text-zinc-950" data-id="element-77" data-mp="2a2s4cf0ginzb">
            Frequently Asked Questions
          </h2>
        </div>
        <div className="space-y-4" data-id="element-78" data-mp="253xb0j4v5h0y">
          {faqs.map((faq, index) => <div key={faq.q} className="bg-white border border-zinc-200 rounded-xl overflow-hidden shadow-sm" data-id="element-79" data-mp="20315600ybksw" data-mpi={index}>
              <button type="button" className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-violet-600" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-80" data-mp="oow1770qnaxk">
                <span className="font-bold text-lg text-zinc-950 pr-8" data-id="element-81" data-mp="1pkgy034y89ms">{faq.q}</span>
                <ChevronDown className={`text-violet-600 transition-transform duration-200 ease-out shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-82" data-mp="1apat5jhlagv1" />
              </button>
              <AnimatePresence initial={false} data-id="element-83" data-mp="16pidynxoxcgp">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-84" data-mp="s0m9f0uuehku">
                    <div className="px-6 pb-5 text-zinc-600 border-t border-zinc-200 pt-4" data-id="element-85" data-mp="2pmn3nt8u7pyk">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}